import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import ColorSwitcher from './components/common/ColorSwitcher';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import ModalContainer from './components/modal/ModalContainer';
import {isMultiColorActive} from './constants/defaultValues';
import {setGoogleAuthStatus} from "./redux/authUser/actions";
import {getDirection} from './helpers/Utils';
import { defaults } from 'react-chartjs-2';
import i18n from './services/i18n';
import error from './views/error';
import Api from "./services/Api";
import user from './views/user';
import app from './views/app';
import main from './views';

export const AuthRoute = ({component: Component, isLoggedIn, ...rest}) => (
  <Route
    {...rest}
    render={props => {
      if (!isLoggedIn) {
        localStorage.clear();
      }
      return isLoggedIn ? (
          <Component {...props} />
        ) :
        <Redirect to={{pathname: '/user/login', state: {from: props.location}}}/>;
    }}
  />
);

class App extends Component {
  constructor(props) {
    super(props);

    const {locale} = props;
    i18n.changeLanguage(locale);
    defaults.global.defaultFontFamily = 'IRANSans';
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.checkGoogleAuthStatus();
    }
  }

  checkGoogleAuthStatus = async () => {
    try {
      const {data} = await Api.invoke(
        "GET",
        "/v2/admin-ui/googleAuth/status",
        null,
        null,
      );
      this.props.setGoogleAuthStatus(data);
      if (data.enabled) {
        if (!data.registered) {
          await Api.logOut();
        }
      }
    } catch (e) {
      await Api.logOut();
    }
  }

  render() {
    const {isLoggedIn} = this.props;
    return (
      <div className="h-100">
        <React.Fragment>
          <NotificationContainer/>
          <ModalContainer/>
          {isMultiColorActive && <ColorSwitcher/>}
          <Router>
            <Switch>
              <AuthRoute path="/dashboard" isLoggedIn={isLoggedIn} component={app}/>
              <Route path="/user" component={user}/>
              <Route path="/error" exact component={error}/>
              <Route path="/" exact component={main}/>
              <Redirect to="/error"/>
            </Switch>
          </Router>
        </React.Fragment>
      </div>
    );
  }
}

const mapStateToProps = ({authUser, settings}) => {
  const {isLoggedIn} = authUser;
  const {locale} = settings;
  return {isLoggedIn, locale};
};

const mapActionsToProps = {
  setGoogleAuthStatus,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(App);
